import { DispensariesPageEntry } from 'src/dispensaries/dispensaries-page-entry';
import { MainLayout } from 'components/layouts/main-layout';

DispensariesPageEntry.layout = MainLayout;

export default DispensariesPageEntry;
